import { useMemo } from "react";

import { ClusterIcon } from "./icons";

interface ClusterPinProps {
  count: number;
  isActive?: boolean;
}

export default function ClusterPin({
  count,
  isActive = false,
}: ClusterPinProps) {
  const label = useMemo(() => {
    if (count > 50) {
      return "50+";
    }
    if (count > 40) {
      return "40+";
    }
    if (count > 30) {
      return "30+";
    }
    if (count > 20) {
      return "20+";
    }
    if (count > 10) {
      return "10+";
    }
    if (count > 5) {
      return "5+";
    }
    return count.toString();
  }, [count]);

  return (
    <div className="relative cursor-pointer">
      <ClusterIcon state={isActive ? "active" : "normal"} />
      <div className="absolute inset-0 flex items-center justify-center">
        <p className="text-center font-bold text-10 text-shadow-0-0-10 text-shadow-rich-black/30 text-white leading-normal">
          {label}
        </p>
      </div>
    </div>
  );
}
